import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function DragNDropIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22473 3.2753C7.4688 3.51937 7.86453 3.51937 8.10861 3.2753L8.70833 2.67557L8.70833 11.1667C8.70833 11.5119 8.98816 11.7917 9.33333 11.7917C9.67851 11.7917 9.95833 11.5119 9.95833 11.1667L9.95833 2.67557L10.5581 3.2753C10.8021 3.51937 11.1979 3.51937 11.4419 3.2753C11.686 3.03122 11.686 2.63549 11.4419 2.39141L9.77528 0.724745C9.5312 0.480668 9.13547 0.480668 8.89139 0.724745L7.22473 2.39141C6.98065 2.63549 6.98065 3.03122 7.22473 3.2753Z"
        fill="currentColor"
      />
      <path
        d="M3.29167 11.3245L3.89139 10.7247C4.13547 10.4807 4.5312 10.4807 4.77528 10.7247C5.01935 10.9688 5.01935 11.3645 4.77528 11.6086L3.10861 13.2753C2.86453 13.5194 2.4688 13.5194 2.22473 13.2753L0.558058 11.6086C0.313981 11.3646 0.313981 10.9688 0.558058 10.7247C0.802136 10.4807 1.19786 10.4807 1.44194 10.7247L2.04167 11.3245L2.04167 2.83335C2.04167 2.48818 2.32149 2.20835 2.66667 2.20835C3.01184 2.20835 3.29167 2.48818 3.29167 2.83335L3.29167 11.3245Z"
        fill="currentColor"
      />
    </SvgIcon>

  );
}
